import { render, staticRenderFns } from "./BehaviorCrud.vue?vue&type=template&id=2e3880c6&"
import script from "./BehaviorCrud.vue?vue&type=script&lang=js&"
export * from "./BehaviorCrud.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports